import { useLayoutEffect, useState, type RefObject } from "react";

/**
 * Whether a dropdown anchored to `anchorRef` should open upward: when the room below the anchor —
 * down to a sticky bottom bar (any element with `data-bottom-bar`, e.g. the invoice creation
 * footer) or the window edge — is too small for the list, and there's more room above.
 * Re-measured each time the list opens.
 */
export function useDropDirection(anchorRef: RefObject<HTMLElement | null>, open: boolean, listHeight = 280): "down" | "up" {
    const [direction, setDirection] = useState<"down" | "up">("down");

    useLayoutEffect(() => {
        if (!open || !anchorRef.current) return;
        const anchor = anchorRef.current.getBoundingClientRect();
        const bar = document.querySelector<HTMLElement>("[data-bottom-bar]")?.getBoundingClientRect();
        const bottomLimit = bar && bar.height > 0 ? Math.min(bar.top, window.innerHeight) : window.innerHeight;
        const below = bottomLimit - anchor.bottom;
        const above = anchor.top;
        setDirection(below < listHeight && above > below ? "up" : "down");
    }, [open, anchorRef, listHeight]);

    return direction;
}
